export default {
  "0": "Tivemos um problema de comunicação. Por favor, tente novamente.",
  CONN_ERROR: "Tivemos um problema de comunicação. Por favor, tente novamente.",
  INVALID_FIELD: "Campo inválido.",
  NOT_FOUND: "CNPJ não encontrado.",
  CNPJ_BLACKLIST:
    "Olá, o CNPJ informado já está cadastrado, em breve um executivo comercial do SBT entrará em contato com você.",
  CITY_NOT_SUPPORTED: "Sua localidade ainda não é coberta pelo SBT Ads.",
  LOGIN_INVALID: "Dados de acesso incorretos. Tente novamente.",
  INVALID_CAMPAIGN: "Campanha não encontrada.",
  GOINSIDE_EXISTS:
    "Olá, o CNPJ informado já está cadastrado, em breve um executivo comercial do SBT entrará em contato com você.",
  GOINSIDE_NOT_ACTIVE:
    "Olá, o CNPJ informado já está cadastrado, em breve um executivo comercial do SBT entrará em contato com você.",
  INVALID_STATUS: "A empresa informada está inativada ou com restrições.",
  INVALID_CNAE: "A empresa informada está inativada ou com restrições.",
  INVALID_CC_DATA:
    "Dados de cartão inválidos. Por favor confirme todos os dados.",
  CNPJ_EXISTS: "CNPJ já cadastrado",
  EMAIL_EXISTS: "E-mail já cadastrado no sistema",
  EMAIL_UNCONFIRMED: "E-mail não validado",
  TOO_MANY_REQUESTS: "Tente novamente mais tarde",
  ExpiredCodeException: "Código expirado",
  UserNotConfirmedException: "Usuário não confirmado",
  STATUS_TEXT: {
    DRAFT: "Rascunho",
    AWAITING_MIDIA: "Aguardando envio mídia",
    PENDING_PAYMENT: "Pagamento pendente",
    AUTHORIZED_PAYMENT: "Pagamento autorizado",
    IN_PROCESS_PAYMENT: "Pagamento em processo",
    IN_MEDIATION_PAYMENT: "Pagamento mediado",
    IN_ANALYSIS_PAYMENT: "Pagamento em análise",
    REJECTED_PAYMENT: "Pagamento rejeitado",
    CANCELLED_PAYMENT: "Pagamento cancelado",
    REFUNDED_PAYMENT: "Pagamento reembolsado",
    CHARGED_BACK_PAYMENT: "Pagamento reembolsado",
    WAITING_PAYMENT: "Pagamento em processo",
    APPROVED_PAYMENT: "Pagamento aprovado",
    SETTLED_PAYMENT: "Pagamento autorizado",
    DONE: "Encerrado"
  } as StatusText,
  STATUS_GROUP: {
    DRAFT: "Rascunhos",
    AWAITING_MIDIA: "Aguardando envio mídia",
    PENDING_PAYMENT: "Pagamento pendente",
    AUTHORIZED_PAYMENT: "Pagamento autorizado",
    IN_PROCESS_PAYMENT: "Pagamento em processo",
    IN_MEDIATION_PAYMENT: "Pagamento mediado",
    IN_ANALYSIS_PAYMENT: "Pagamento em análise",
    REJECTED_PAYMENT: "Pagamento rejeitado",
    CANCELLED_PAYMENT: "Pagamento cancelado",
    REFUNDED_PAYMENT: "Pagamento reembolsado",
    CHARGED_BACK_PAYMENT: "Pagamento reembolsado",
    WAITING_PAYMENT: "Pagamento em processo",
    APPROVED_PAYMENT: "Pagamento aprovado",
    SETTLED_PAYMENT: "Pagamento autorizado",
    DONE: "Encerrado"
  },
  MOIP_PK: {
    DEVELOP: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApIl/JlV5mrGVt5JFrC2R
5aAR2x0433h/C2peoZarhtdC/PgmQAUx/wHPG04X1qD0RWvN8VJJ62lNxiaWk7B/
lpl3pzqckT6RrFsIhmXZCEvZ8PG/C2V0Rkn82Fx9O4PjWjFw4+07KxjAYgsooXZy
/39go635xFqUGRiWiJXHD/6u2Ji330mAtr6y5F9ntCfvdDpimo0lkwKvIIjan2ry
S4NvhdAAnGMMVC4Eaapm+tMOqCrRPeqAswFH3EkEIYUFnX8tgoPrTUNvGnCklhTk
NcSed2ocHgikWKpz9BhqGLzAlf3WBtkIv/wZ/9NvGRkxgx9aA20UpJ3w6YzAoZtI
dwIDAQAB
-----END PUBLIC KEY-----`,
    PRODUCTION: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvjDXCNYtbApIIDqFx6r8
/TbRDZAE1hjZdA8E6rpLOG2ViNbKl6Q9WFJo9xILLxG3Ug2bFXMYTj94+7aUwnj1
uHzQpe/3F8QQdp7w0F6SmTAfXxBhnGF1rgloof9oOzEWpDW+LfD5wRCxmO5Z9mHd
DijY5sxXjZnZIaq6kSjuDCJT4G7ypMwduNDo0rxkQp0MeYIwVpyxKf7iVuXhiRlf
qbjv6oIb0jY91Vd7ezd74SG509OSC+oznJ1jAMDjasfPesOe8fRIKAs5U8p9SHu6
qISFy18/p2JZQqJMTBPU9mvvl6nirzkbT7B9caekwl0zGoII1rsLKvuwvtWeyFQp
sQIDAQAB
-----END PUBLIC KEY-----`
  },
  PASSWORD: {
    min: 6,
    max: 12
  }
};

export const helpTexts = [
  {
    active: true,
    title: "O que é SBT ADS?",
    text:
      "SBT ADS é uma plataforma de autosserviço que permite ao pequeno e médio empreendedor a compra de espaço publicitário na programação e no ambiente digital do SBT."
  },
  {
    active: false,
    title: "Como anunciar no SBT ADS?",
    text:
      "Anunciar no SBT ADS é muito simples. Qualquer empresa com CNPJ ativo pode criar um anúncio.",
    video: "",
    videoTitle: ""
  },
  {
    active: true,
    title: "O que é uma campanha?",
    text:
      "As campanhas publicitárias consistem em um conjunto de ações de marketing e são executadas de maneira a atingir um objetivo. Além de divulgar um produto ou serviço, a campanha publicitária é uma importante ferramenta para estabelecer a imagem que a marca quer transmitir a seu público-alvo, a qual pode ser realizada tanto de maneira online como offline."
  },
  {
    active: true,
    title: "Como fazer uma campanha de publicidade?",
    items: [
      "1º passo – Informar dados básicos da campanha, além do período, objetivo e o público-alvo.",
      "2º passo – Estabelecer a cobertura, horários e dias em que a campanha aparecerá.",
      "3º passo – Informar o valor do investimento.",
      "4º passo – Definir e customizar um plano de mídia.",
      "5º passo – Escolher uma das opções disponíveis de vídeo comercial.",
      "6º passo – Realizar o pagamento."
    ]
  },
  {
    active: true,
    title: "O que é impacto total na campanha?",
    text:
      "O impacto é a multiplicação da cobertura (quantidade de pessoas diferentes impactadas) pela frequência média dos anúncios. Portanto, trata-se de uma métrica que ajuda a entender a probabilidade de sucesso de uma campanha em diferentes meios de comunicação."
  },
  {
    active: true,
    title: "Para que serve o plano de mídia?",
    text:
      "O plano de mídia é um trabalho estratégico que tem como finalidade definir quais meios de comunicação serão usados. Nessa atividade, é avaliada uma série de fatores que têm impacto direto na decisão, como por exemplo, a produção de material, investimento e estratégia da campanha."
  },
  {
    active: true,
    title: "Qual o objetivo da campanha?",
    text: `
    <p><b>- Reconhecimento de marca:</b> buscar um maior conhecimento do serviço ou produto anunciado nos meios de comunicação.</p>
    <p><b>- Tráfego online:</b> atrair maior volume de pessoas dentro do site do cliente.</p>
    <p><b>- Vendas de produtos ou serviços:</b> adquirir uma comunicação atrativa para compras de produtos, dispondo de uma estratégia de mídia com cobertura e frequência.</p>
    `
  },
  // {
  //   active: true,
  //   title: 'Como é cobrado o valor da midia para clientes diretos?',
  //   text: 'O valor de mídia para clientes diretos é sempre pelo bruto negociado.',
  // },
  {
    active: true,
    title: "O que é ANCINE?",
    text:
      "ANCINE é a sigla da Agência Nacional do Cinema, sendo um órgão oficial do Governo Federal do Brasil, cujo objetivo é fomentar, regular, e fiscalizar a indústria cinematográfica e videofonográfica nacional."
  },
  {
    active: true,
    title: "O que é a taxa CONDECINE?",
    text: `
    <p>CONDECINE é a sigla da Contribuição para o Desenvolvimento da Indústria Cinematográfica Nacional, a qual incide sobre a veiculação, a produção, o licenciamento e a distribuição de obras cinematográficas e videofonográficas com fins comerciais. A arrecadação da taxa CONDECINE compõe o Fundo Setorial do Audiovisual (FSA) sendo revertida diretamente para o desenvolvimento do setor.
    </p>

    <p>O pagamento da taxa CONDECINE é obrigatório?<br>
    O pagamento da taxa CONDECINE torna-se obrigatório quando a veiculação do seu vídeo for feita em uma exibidora que atenda ao menos um município com mais de 1 milhão de habitantes. No caso da veiculação em exibidoras que possuam todos os municípios com menos de 1 milhão de habitantes, o pagamento da taxa CONDECINE torna-se isento.
    </p>

    <p>Como é feito o pagamento da taxa CONDECINE?<br>
    Caso a obrigatoriedade da taxa CONDECINE seja identificada no seu plano de mídia, a cobrança estará diretamente vinculada ao vídeo do seu anúncio criado na plataforma SBT ADS.
    Se você possui um vídeo produzido e fará upload na plataforma SBT ADS, o pagamento da taxa CONDECINE e o registro CRT (Certificado de Registro de um Título ou Obra), obrigatórios para a aprovação de uso do seu vídeo, são de sua responsabilidade.
    </p>

    <p>Fique atento:<br>
    Vídeos que não possuem pagamento de taxa CONDECINE só podem ser vinculados em planos de mídias de exibidoras com veiculação em municípios com menos de 1 milhão de habitantes. Vale destacar que, vídeos que possuem o pagamento dessa taxa tem seu uso livre, ou seja, podem ser veiculados em qualquer exibidora.
    </p>
    `
  },
  {
    active: true,
    title: "Para a TV, qual a importância da ANCINE em todos os filmes?",
    text:
      "A finalidade da regulação é de cumprir com o interesse público, por meio de metas pré-estabelecidas, sejam econômicas ou sociais. Na regulação do audiovisual, essas duas vertentes se mesclam, promovendo ganhos intangíveis, tanto na ampliação como na democratização do acesso à cultura e informação."
  },
  {
    active: true,
    title: "O que é multiplicidade?",
    text:
      "Um comercial é considerado múltiplo, quando há mais de uma marca no mesmo material e existe qualificação dessa marca. Por exemplo: quando aparece o logo ou a qualificação do processador da marca Y, em um comercial de notebook da marca X. Nesse caso, faz-se necessário a cobrança do comercial múltiplo."
  },
  {
    active: true,
    title: "Qual a porcentagem de cobrança da multiplicidade?",
    text: "A multiplicidade possui uma cobrança de 30%."
  },
  {
    active: true,
    title: "Quais são as formas de pagamento através da plataforma?",
    text:
      "No momento, estamos aceitando pagamentos apenas via cartão de crédito."
  }
];
